import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const dynamicCocktailSpotlightDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.cocktailSpotlight,
  componentType: LAYOUT_COMPONENT_TYPE.dynamicCocktailSpotlight,
  registryBlockKey: REGISTRY_BLOCK.presentation.dynamicCocktailSpotlight,
  displayOrder: 3,
  content: {
    sectionTitle: loc3('Cocktail der Woche', 'Cocktail of the week', 'Cocktail tuần này'),
    cocktailName: loc3('Isar Negroni', 'Isar Negroni', 'Isar Negroni'),
    description: loc3(
      'Gin, bitterer Campari und vermouth — gerührt, mit Orange.',
      'Gin, bitter Campari and vermouth — stirred, with orange.',
      'Gin, Campari đắng và vermouth — khuấy, kèm cam.',
    ),
    price: loc3('13 €', '13 €', '13 €'),
    badgeText: loc3('Heute im Spotlight', 'Tonight’s spotlight', 'Spotlight tối nay'),
  },
  media: {
    cocktailImage:
      'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=960&q=80',
  },
};
